export default [
  {
    id: 1,
    name: '移动互联网'
  },
  {
    id: 2,
    name: '电子商务'
  },
  {
    id: 4,
    name: '金融'
  },
  {
    id: 8,
    name: '企业服务'
  },
  {
    id: 16,
    name: '教育'
  },
  {
    id: 32,
    name: '文化娱乐'
  },
  {
    id: 34,
    name: '游戏'
  },
  {
    id: 38,
    name: 'O2O'
  },
  {
    id: 42,
    name: '硬件'
  },
  {
    id: 46,
    name: '生活服务'
  },
  {
    id: 50,
    name: '广告营销'
  },
  {
    id: 54,
    name: '旅游'
  },
  {
    id: 58,
    name: '数据服务'
  },
  {
    id: 62,
    name: '社交网络'
  },
  {
    id: 66,
    name: '分类信息'
  },
  {
    id: 70,
    name: '信息安全'
  },
  {
    id: 74,
    name: '招聘'
  },
  {
    id: 78,
    name: '区块链'
  },
  {
    id: 82,
    name: '人工智能'
  },
  {
    id: 86,
    name: '医疗健康'
  },
  {
    id: 518,
    name: '物联网/AloT'
  },
  {
    id: 512,
    name: '其他'
  }
]
